import en from '../JsonLang/en.json'
export const lang = { ...en }